<script lang="ts">
	import Fa from 'svelte-fa';
	import {
		faInfoCircle,
		faCheckCircle,
		faExclamationTriangle,
		faLightbulb,
		faTimesCircle,
		type IconDefinition
	} from '@fortawesome/free-solid-svg-icons';

	interface Props {
		variant?: 'info' | 'success' | 'warning' | 'error' | 'tip';
		title?: string | null;
		icon?: IconDefinition | null; // allow icon overrides
		showBackground?: boolean; // toggle for background color
		children?: import('svelte').Snippet;
	}

	let {
		variant = 'info',
		title = null,
		icon = null,
		showBackground = false,
		children
	}: Props = $props();

	const styles = {
		info: {
			icon: faInfoCircle,
			border: 'border-primary-300',
			bg: 'bg-primary-100',
			text: 'text-primary-900'
		},
		success: {
			icon: faCheckCircle,
			border: 'border-success-500/50',
			bg: 'bg-success-800/50',
			text: 'text-success-300'
		},
		warning: {
			icon: faExclamationTriangle,
			border: 'border-warning-300',
			bg: 'bg-warning-200',
			text: 'text-warning-900'
		},
		error: {
			icon: faTimesCircle,
			border: 'border-error-300',
			bg: 'bg-error-200',
			text: 'text-error-700'
		},
		tip: {
			icon: faLightbulb,
			border: 'border-secondary-300',
			bg: 'bg-secondary-100',
			text: 'text-secondary-900'
		}
	};
</script>

<div
	class={`rounded-container border border-l-4 p-3 ${styles[variant].border} ${showBackground ? styles[variant].bg : ''} ${showBackground ? styles[variant].text : ''}`}
>
	<div class="flex flex-col">
		<div class="flex items-center gap-1 text-base">
			<Fa icon={icon ?? styles[variant].icon} />
			{#if title}
				<p class="font-semibold">{title}</p>
			{/if}
		</div>
		<div class="flex text-sm font-normal">
			{@render children?.()}
		</div>
	</div>
</div>
